import * as plugins from './smartyaml.plugins.js';

export let yamlStringToObject = async (
  yamlStringArg: string,
): Promise<any> => {
  return plugins.yaml.parse(yamlStringArg);
};

export let objectToYamlString = async (
  objectArg: unknown
): Promise<string> => {
  return plugins.yaml.stringify(objectArg);
};

export let getYamlDocFromString = async (stringArg: string) => {
  return plugins.yaml.parseDocument(stringArg);
};
